import { SummaryPipe } from './summary.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule }    from '@angular/http';
import { AppComponent } from './app.component';
import { IndexComponent } from './index/index-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ToastModule, ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { RouterModule } from '@angular/router';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { ShopAuthGuard } from './guards/shopAuthGuard';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { TellUsMoreComponent } from './tell-us-more/tell-us-more.component';
import { ServicesComponent } from './services/services.component';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    SummaryPipe,
    UserProfileComponent,
    PageNotFoundComponent,
    NavbarComponent,
    FooterComponent,
    ContactUsComponent,
    AboutUsComponent,
    TellUsMoreComponent,
    ServicesComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    RouterModule.forRoot([
      {path: 'home', component: IndexComponent},
      {path: '', component: IndexComponent},
      {path: 'services', component: ServicesComponent},
      {path: 'contact-us', component: ContactUsComponent},
      {path: 'about-us', component: AboutUsComponent},
      {path: 'tell-us-more', component: TellUsMoreComponent},
      //{path: 'userProfile/:email', component: UserProfileComponent},
      //[routerLink]="['/userProfile', user.id]"
      //{path: 'telescopes', component: TelescopesComponent, canActivate: [ShopAuthGuard]},
      {path: '**', component: PageNotFoundComponent}
    ]) 
  ],
  providers: [ToastsManager, ToastOptions, ShopAuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/app.module.ts